// Global toast service using Notyf
// Can be imported by any controller that needs to show toasts
import { Notyf } from "notyf"

// Singleton instance
let notyfInstance = null

export function getNotyf() {
  if (!notyfInstance) {
    notyfInstance = new Notyf({
      duration: 4000,
      position: { x: "right", y: "top" },
      dismissible: true,
      ripple: true,
      types: [
        {
          type: "success",
          background: "#10b981",
          icon: {
            className: "notyf__icon--success",
            tagName: "i"
          }
        },
        {
          type: "error",
          background: "#ef4444",
          icon: {
            className: "notyf__icon--error",
            tagName: "i"
          }
        },
        {
          type: "warning",
          background: "#f59e0b",
          icon: false
        },
        {
          type: "info",
          background: "#3b82f6",
          icon: false
        }
      ]
    })
  }
  return notyfInstance
}

export const toast = {
  success(message) {
    getNotyf().success(message)
  },

  error(message) {
    getNotyf().error(message)
  },

  warning(message) {
    getNotyf().open({ type: "warning", message })
  },

  info(message) {
    getNotyf().open({ type: "info", message })
  },

  // Generic show method
  show(type, message) {
    switch (type) {
      case "success":
        this.success(message)
        break
      case "error":
        this.error(message)
        break
      case "warning":
        this.warning(message)
        break
      case "info":
      default:
        this.info(message)
        break
    }
  }
}

// Also expose globally for inline scripts
window.Toast = toast

export default toast
